import { ErrorHandler, Provider } from "@angular/core";
import { HbErrorHandler } from "../interceptors/error.handler";

export function provideErrorHandler(): Provider {
  return {
    provide: ErrorHandler,
    useClass: HbErrorHandler,
    multi: false,
  };
}
